import { BILLING_TABS } from "./BillingConstant";
import { useState } from "react";
import PatientSectionWrapper from "../PatientSectionWrapper";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import CustomTabs from "../../../../components/app/CustomTabs";

const PatientBillingLayout = () => {
  const outletContext = useOutletContext<{ patientId: string } | undefined>();
  const [activeTab, setActiveTab] = useState<string>(() => {
    const currentTab = location.pathname.split("/").pop();
    return currentTab == "billing"
      ? BILLING_TABS[0].value
      : (currentTab as string);
  });
  const navigate = useNavigate();
  const handleTabChange = (v: string) => {
    setActiveTab(v);
    navigate(v);
  };
  return (
    <PatientSectionWrapper
      header={
        <CustomTabs
          tabsData={BILLING_TABS}
          value={activeTab}
          onChange={handleTabChange}
        />
      }
    >
      <Outlet context={outletContext} />
    </PatientSectionWrapper>
  );
};
export default PatientBillingLayout;
